'use client';

import { cn } from '@/app/utils/cn';
import LinkNoPrefetch from '@/components/link-noprefetch';
import { useDemoModal } from '@/components/demos/DemoModalProvider';

export function NavDemoButtons({ className, buttonClassName }) {
    const { openScheduleModal } = useDemoModal();

    return (
        <div className={cn('flex items-center gap-2', className)}>
            <LinkNoPrefetch
                className={cn(
                    'btn text-nowrap text-xs lg:text-sm px-2 lg:px-3 py-1 lg:py-1.5 text-gray-600 border-gray-300 hover:text-gray-900 hover:border-gray-500 dark:text-gray-300 dark:border-gray-600 dark:hover:text-white dark:hover:border-gray-400',
                    buttonClassName
                )}
                href="/demo-center">
                Demo Center
            </LinkNoPrefetch>
            <button
                type="button"
                onClick={() => openScheduleModal('navbar')}
                className={cn(
                    'btn text-nowrap text-xs lg:text-sm px-2 lg:px-3 py-1 lg:py-1.5 bg-blue text-blue-200 border-blue hover:bg-indigo hover:text-white hover:border-indigo dark:bg-fuschia-700 dark:text-white dark:border-fuschia-700 dark:hover:bg-fuschia-800 dark:hover:border-fuschia-800',
                    buttonClassName
                )}>
                Book a Meeting
            </button>
        </div>
    );
}

export function ButtonRequestDemo({ className }) {
    return <NavDemoButtons className={className} />;
}
